import { Card, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React, { useCallback } from 'react';
import '../../css/marques/marqueCardView.css';

const MarqueGridData = React.memo(({ index, style, data }) => {

    const { marques, columns, filteredMarquesCount } = data;
    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredMarquesCount);

    const handleMarqueClick = useCallback((marqueId) => navigate(`marque_details/${marqueId}`), [navigate]);

    return (
        <Grid style={style} key={index} container spacing={2}>
            {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                const marqueIndex = startIndex + idx;
                const marque = marques[marqueIndex];

                return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={marque ? marque.id : `skeleton-${marqueIndex}`}>
                        <Card className='marques_gridview_card'>
                            <CardActionArea onClick={marque ? () => handleMarqueClick(marque?.id) : undefined}>
                                {marque ? (
                                    <>
                                        <CardMedia
                                            component="img"
                                            height="192"
                                            loading='lazy'
                                            decoding='async'
                                            image={entityGridPhotoUrl(marque, 'marque', { size: 'small', fallback: machineDefaultImage })}
                                            alt={marque?.name}
                                        />
                                        <CardContent className='marques_gridview_card_CardContent'>
                                            <Typography className='marques_gridview_marque_name' component="div">{marque?.name}</Typography>
                                            <Typography className='marques_gridview_marque_adress' component="div">{marque?.description || '--'}</Typography>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rectangular" height={192} />
                                        <CardContent className='machines_gridview_card_CardContent'>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </CardContent>
                                    </>
                                )}
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
});

export default MarqueGridData;